export interface ILogisticsEdit {
    swapNumber: string;
    position: number;
    logisticsProvider: number;
    jobNumber: string;
    donor: {
        center: string,
        centerId: number;
        alias: string,
        surgeon: number
    },
    recipient: {
        center: string,
        centerId: number;
        alias: string
        surgeon: number;
    },
    
}
